module.exports = __webpack_public_path__ + "img/footIcon.d0289dc0.jpg";